import Vue from 'vue';

const SportClassUtils = {

    getSportClass(){
        return Vue.axios
            .get(`sportClass`
            )
            .then(response => {
                console.log('return sportClasses:' + response.data);
                return response.data;
            });
    }

};

export default SportClassUtils;
